import { useCallback, useState } from "react";

export const useToggle = (initial) => {
  const [open, setOpen] = useState(initial);

  return [open, useCallback(() => setOpen((status) => !status), [])];
};
